import type { AxiosResponse, AxiosInstance } from 'axios';
import type { Workspaces } from './interfaces';

export class WorkspacesFolderClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getFolder = (data: Workspaces.GetFolder.Request): Promise<AxiosResponse<Workspaces.GetFolder.Response>> => {
    return this.authenticatedClient.get<Workspaces.GetFolder.Response>(`/workspaces/folders/${data.folderId}`);
  };
}

export default WorkspacesFolderClient;